import { useEffect, useState } from "react";

/** Returns a value after it has remained unchanged for the given delay. */
export function useDebounce<T>(value: T, delay: number): T {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebouncedValue(value), delay);

    return () => clearTimeout(timer);
  }, [delay, value]);

  return debouncedValue;
}
